class EventModel {
  constructor(
    eventName = '',
    eventType = '',
    eventAction = '',
    eventEffect = '',
    eventPosition = 1,
    eventTimestamp = new Date()
  ) {
    this.name = eventName;
    this.type = eventType;
    this.action = eventAction;
    this.effect = eventEffect;
    this.position = eventPosition;
    this.timestamp = eventTimestamp;
  }

  // TODO: Implement any neccesary setters and getters!
  addTrackingAttributes(attributes = {}) {
    Object.entries(attributes).forEach(attribute => {
      const attributeName = attribute[0];
      const attributeValue = attribute[1];
      this[attributeName] = attributeValue;
    });
  }

  getTrackingObject() {
    const returnObject = {};

    Object.entries(this).forEach(attribute => {
      const attributeName = attribute[0];
      const attributeValue = attribute[1];

      returnObject[attributeName] = attributeValue;
    });

    return returnObject;
  }
}

export default EventModel;
